/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ row: NonNullable<unknown> }} Sync_Run_Error_RowInputs */

const en_sync_run_error_row = /** @type {(inputs: Sync_Run_Error_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Row ${i?.row}`)
};

/**
* | output |
* | --- |
* | "Row {row}" |
*
* @param {Sync_Run_Error_RowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_run_error_row = /** @type {((inputs: Sync_Run_Error_RowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Run_Error_RowInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_run_error_row(inputs)
});